import {
  Avatar,
  Button,
  Flex,
  Icon,
  Text,
  useColorModeValue,
  useColorMode,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
} from '@chakra-ui/react';
import { SidebarResponsive } from 'components/sidebar/Sidebar';
import PropTypes from 'prop-types';
import React, { useEffect } from 'react';
import { FaEthereum } from 'react-icons/fa';
import { RiLockPasswordLine } from 'react-icons/ri';
import { IoMdMoon, IoMdSunny } from 'react-icons/io';
import routes from 'routes';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { getUserData } from '../../redux/actions/Admin.action';

export default function HeaderLinks(props) {
  const { secondary } = props;
  const { colorMode, toggleColorMode } = useColorMode();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const userData = useSelector((state) => state.admin);

  // Chakra Color Mode
  const navbarIcon = useColorModeValue('gray.400', 'white');
  const menuBg = useColorModeValue('white', 'navy.800');
  const textColor = useColorModeValue('secondaryGray.900', 'white');
  const ethColor = useColorModeValue('gray.700', 'white');
  const ethBg = useColorModeValue('secondaryGray.300', 'navy.900');
  const ethBox = useColorModeValue('white', 'navy.800');
  const shadow = useColorModeValue(
    '14px 17px 40px 4px rgba(112, 144, 176, 0.18)',
    '14px 17px 40px 4px rgba(112, 144, 176, 0.06)',
  );
  const borderColor = useColorModeValue('#E6ECFA', 'rgba(135, 140, 189, 0.3)');

  const handleLogOut = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('type');
    localStorage.clear();
    navigate('/auth/sign-in');
    window.location.reload();
  };

  useEffect(() => {
    dispatch(getUserData());
  }, [dispatch]);

  return (
    <Flex
      w={{ sm: '100%', md: 'auto' }}
      alignItems="center"
      flexDirection="row"
      flexWrap={secondary ? { base: 'wrap', md: 'nowrap' } : 'unset'}
      p="10px"
      borderRadius="30px"
      position="relative"
      zIndex="99"
    >
      <Flex
        bg={ethBg}
        display={secondary ? 'flex' : 'none'}
        borderRadius="30px"
        ms="auto"
        p="6px"
        align="center"
        me="6px"
      >
        <Flex
          align="center"
          justify="center"
          bg={ethBox}
          h="29px"
          w="29px"
          borderRadius="30px"
          me="7px"
        >
          <Icon color={ethColor} w="9px" h="14px" as={FaEthereum} />
        </Flex>
        <Text
          w="max-content"
          color={ethColor}
          fontSize="sm"
          fontWeight="700"
          me="6px"
        >
          1,924
          <Text as="span" display={{ base: 'none', md: 'unset' }}>
            {' '}
            ETH
          </Text>
        </Text>
      </Flex>

      <SidebarResponsive routes={routes} />

      {/* Change Password Button */}
      { localStorage.getItem('type') === 'Admin' ? <Button
        p="0"
        bg="#E6EFF7"
        borderRadius="50%"
        w="40px"
        h="40px"
        display="flex"
        alignItems="center"
        justifyContent="center"
        onClick={() => navigate('/master/changePassword')}
        me="10px"
        _hover={{ bg: '#D8E3F0' }}
        _active={{ bg: '#C7D4E9' }}
      >
        <Icon as={RiLockPasswordLine} w="20px" h="20px" color="theme-dark" />
      </Button> : null}

      {/* User Profile Menu */}
      <Menu>
        <MenuButton p="0px">
          <Avatar
            _hover={{ cursor: 'pointer' }}
            name={userData?.getUserData?.data?.auth?.name}
            bg="#E6EFF7"
            color="theme-dark"
            size="sm"
            w="40px"
            h="40px"
            ml={{ base: '20px', md: '0' }}
          />
        </MenuButton>
        <MenuList
          boxShadow={shadow}
          p="0px"
          mt="10px"
          borderRadius="20px"
          bg={menuBg}
          border="none"
          ml={{ base: '20px', md: '0' }}
        >
          <Flex w="100%" mb="0px">
            <Text
              ps="20px"
              pt="16px"
              pb="10px"
              w="100%"
              borderBottom="1px solid"
              borderColor={borderColor}
              fontSize="sm"
              fontWeight="700"
              color={textColor}
            >
              👋 Hey, {userData?.getUserData?.data?.auth?.name}
            </Text>
          </Flex>
          <Flex>
            <Text
              ps="20px"
              pt="16px"
              pb="10px"
              w="100%"
              borderBottom="1px solid"
              borderColor={borderColor}
              fontSize="sm"
              fontWeight="700"
              color={textColor}
            >
              {userData?.getUserData?.data?.auth?.email}
            </Text>
          </Flex>
          <Flex flexDirection="column" p="10px">
            <MenuItem
              _hover={{ bg: 'none' }}
              _focus={{ bg: 'none' }}
              borderRadius="8px"
              px="14px"
              onClick={() => navigate('/master/changePassword')}
            >
              <Text fontSize="sm">Change Password</Text>
            </MenuItem>
            <MenuItem
              _hover={{ bg: 'none' }}
              _focus={{ bg: 'none' }}
              color="red.400"
              borderRadius="8px"
              px="14px"
              onClick={handleLogOut}
            >
              <Text fontSize="sm">Log out</Text>
            </MenuItem>
          </Flex>
        </MenuList>
      </Menu>
    </Flex>
  );
}

HeaderLinks.propTypes = {
  variant: PropTypes.string,
  fixed: PropTypes.bool,
  secondary: PropTypes.bool,
  onOpen: PropTypes.func,
};